import { useMemo } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import { getCampaignsAPI, patchUpdateCampaignsAPI } from "api/campaign-voucher";
import { CampaignUpdateFormTypes } from "schemas/campaign-voucher-schemas";
import { QUERY_KEYS } from "constants/querykeys";

export const useCampaignsQuery = () => {
  const queryKey = [QUERY_KEYS.VOUCHER_LIST]
  const queryFn = async () => {
    return await getCampaignsAPI()
  }
  const queryOptions = {
    refetchOnWindowFocus: false,
    queryKey,
    queryFn,
  }
  const query = useQuery(queryOptions)

  return {
    query,
  }
}

export const useCampaignsMutation = () => {
  const { mutateAsync } = useMutation({
    mutationFn: getCampaignsAPI,
    mutationKey: [QUERY_KEYS.REPORT_MERCHANT_SEARCH],
  });

  const onSearchCampaignsLoader = async (inputValue: string) => {
    const data = await mutateAsync();
    return data.data
      .filter((c) =>
        c.campaignName.toLowerCase().includes(inputValue.toLowerCase())
      )
      .map((c) => ({
        label: c.campaignName,
        value: String(c.campaignId),
      }));
  };

  return {
    onSearchCampaignsLoader,
  }
}

export const useCampaignsSelectQuery = () => {
  const { query } = useCampaignsQuery()

  const campaignOptions = useMemo(() => {
    const data = query.data?.data || []
    return data.map((item) => ({
      label: item.campaignName + " (ID: " + item.campaignId + ")",
      value: String(item.campaignId),
    }))
  }, [query.data])

  return { campaignOptions }
}

export const useCampaignUpdate = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (mutationData: { formData: CampaignUpdateFormTypes }) => {
      return patchUpdateCampaignsAPI(mutationData.formData)
    },
    onError: (error: string) => {
      console.error('Campaign update error:', error)
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === QUERY_KEYS.VOUCHER_LIST
      })
    },
  })

  return mutation
}